import React from 'react';
import PropTypes from 'prop-types';
import ClampLines from 'react-clamp-lines';

import './PostListItem.scss';

const moment = require('moment');

class PostListItem extends React.Component {
  render() {
    if (this.props.layout === 'full') {
      return (
        <div className="f-post full">
          <a href={`/posts/${this.props.post.slug}`}>
            <div className="f-post--inner">
              <div className="f-image" style={{ backgroundImage: `url(${this.props.post.featured_image})` }}></div>
              <div className="f-synopsis">
                <h2 className="f-title">{this.props.post.title}</h2>
                <p className="f-date">{moment(this.props.post.published).format('MM/DD/YYYY')}</p>
                <ClampLines
                  className="f-desc wide"
                  text={this.props.post.summary}
                  lines={3}
                  ellipsis='...'
                  buttons={false}
                  innerElement="p"
                 />
              </div>
            </div>
          </a>
        </div>
      );
    } else if (this.props.layout === 'half') {
      return (
        <div className="f-post half">
          <a href={`/posts/${this.props.post.slug}`}>
            <div className="f-post--inner">
              <div className="f-image" style={{ backgroundImage: `url(${this.props.post.featured_image})` }}></div>
              <div className="f-synopsis">
                <p className="f-date top">{moment(this.props.post.published).format('MM/DD/YYYY')}</p>
                <h2 className="f-title">{this.props.post.title}</h2>
                <ClampLines
                  className="f-desc"
                  text={this.props.post.summary}
                  lines={3}
                  ellipsis='...'
                  buttons={false}
                  innerElement="p"
                />
              </div>
            </div>
          </a>
        </div>
      )
    } else if (this.props.layout === 'quarter') {
      return (
        <div className="f-post quarter">
          <a href={`/posts/${this.props.post.slug}`}>
            <div className="f-post--inner">
              <div className="f-image" style={{ backgroundImage: `url(${this.props.post.featured_image})` }}></div>
              <div className="f-synopsis">
                <p className="f-date top">{moment(this.props.post.published).format('MM/DD/YYYY')}</p>
                <h2 className="f-title">{this.props.post.title}</h2>
                <ClampLines
                  className="f-desc"
                  text={this.props.post.summary}
                  lines={3}
                  ellipsis='...'
                  buttons={false}
                  innerElement="p"
                />
              </div>
            </div>
          </a>
        </div>
      );
    } else if (this.props.layout === 'eighth') {
      return (
        <div className="f-post eighth">
          <a href={`/posts/${this.props.post.slug}`} onClick={this.props.onClick}>
            <div className="f-post--inner">
              <div className="f-image" style={{ backgroundImage: `url(${this.props.post.featured_image})` }}></div>
              <div className="f-synopsis">
                <p className="f-date top">{moment(this.props.post.published).format('MM/DD/YYYY')}</p>
                <ClampLines
                  className="f-title"
                  text={this.props.post.title}
                  lines={2}
                  buttons={false}
                />
                <ClampLines
                  className="f-desc"
                  text={this.props.post.summary}
                  lines={3}
                  ellipsis='...'
                  buttons={false}
                  innerElement="p"
                />
              </div>
            </div>
          </a>
        </div>
      );
    } else if (this.props.layout === 'related') {
      return (
        <div className="related-post">
          <a href={`/posts/${this.props.post.slug}`}>
            <div className="related-post--inner">
              <ClampLines
                className="related-title"
                text={this.props.post.title}
                lines={2}
                buttons={false}
              />
              <p className="related-date">{moment(this.props.post.published).format('MM/DD/YYYY')}</p>
            </div>
          </a>
        </div>
      )
    }
  }
}

PostListItem.propTypes = {
  layout: PropTypes.string.isRequired,
  post: PropTypes.object.isRequired,
  onClick: PropTypes.func,
}

export default PostListItem;
